/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { api } from "api";

import Surveys from "components/survey/Surveys";
import Tests from "components/survey/Tests";

class SurveyContainer extends Component {
  state = {
    tab1DataFetched: false,
    tab2DataFetched: false,
    surveys: [],
    tests: [],
    currentTab: "#tab1",
  };

  componentDidMount() {
    this.fetchTab1Data();
  }

  fetchTab1Data = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/survey/get-surveys`)
      .then((response) => {
        this.setState({
          tab1DataFetched: true,
          surveys: response.data.data.surveys,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
        this.fetchTab2Data();
      });
  };

  fetchTab2Data = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/test/get-tests`)
      .then((response) => {
        this.setState({
          tab2DataFetched: true,
          tests: response.data.data.tests,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  renderTabbedContent = () => {
    if (!this.state.tab1DataFetched || !this.state.tab2DataFetched) {
      return null;
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Tab.Container
          id="nav-tab"
          defaultActiveKey="#tab1"
          activeKey={this.state.currentTab}
        >
          <nav className="scrollNav">
            <Nav variant="tabs" role="tablist">
              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab1" })}
                  eventKey="#tab1"
                >
                  <Trans desc="Anketler">10705</Trans>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab2" })}
                  eventKey="#tab2"
                >
                  <Trans desc="Testler">10706</Trans>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </nav>

          <Tab.Content>
            <Tab.Pane eventKey="#tab1">
              {this.state.tab1DataFetched && (
                <Surveys surveys={this.state.surveys} />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="#tab2">
              {this.state.tab2DataFetched && <Tests tests={this.state.tests} />}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Kurumsal">10026</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Eğitim Anketi/Testi">10042</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Anket">10042</Trans> / Test
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {}
)(containsLongRunningProcess(requireAuth(SurveyContainer)));
